<div class="flex flex-column consult__section consult__history-personal">
  <div class="col-12 inline-flex flex-wrap consult__section-subheading-group">
    <h3 class="col-12 inline-flex align-items-center lg:col-4 p-0 consult__section-subheading cursor-pointer"
      (click)="expandSection = !expandSection">
      <i class="fas" [style.fontSize.px]="12" [ngClass]="{
        'fa-minus': expandSection,
        'fa-plus': !expandSection
      }"></i>
      <label class="ml-2 mb-0 cursor-pointer">{{screen.heading}}</label>
    </h3>

    <span class="col-12 lg:col-8 p-0 consult__section-help">{{screen.tooltip}}</span>
  </div>

  <span class="flex flex-wrap col-12 px-0" *ngIf="expandSection">
    <!-- ESTOS SON LOS DETALLES DEL ANTECEDENTE FAMILIAR DE ESTE PACIENTE. -->
    <span class="col-3 inline-flex align-items-center">
      <label class="no-margin" for="sexLife">{{screen.sexLife}}</label>
      <p-checkbox name="sexLife" [(ngModel)]="history.sexLife" [binary]="true" [style.marginLeft.px]="16" validation>
      </p-checkbox>
    </span>
    <span class="col-2 inline-flex align-items-center">
      <label class="no-margin" for="biopsy">{{screen.biopsy}}</label>
      <p-checkbox name="biopsy" [(ngModel)]="history.biopsy" [binary]="true" [style.marginLeft.px]="16" validation>
      </p-checkbox>
    </span>
    <span class="col-3 inline-flex align-items-center">
      <label class="no-margin" for="hormonalTherapy">{{screen.hormonalTherapy}}</label>
      <p-checkbox name="hormonalTherapy" [(ngModel)]="history.hormonalTherapy" [binary]="true"
        [style.marginLeft.px]="16" validation></p-checkbox>
    </span>
    <span class="col-2 inline-flex align-items-center">
      <label class="no-margin" for="colposcopy">{{screen.colposcopy}}</label>
      <p-checkbox name="colposcopy" [(ngModel)]="history.colposcopy" [binary]="true" [style.marginLeft.px]="16"
        validation>
      </p-checkbox>
    </span>
    <span class="col-2 inline-flex align-items-center">
      <label class="no-margin" for="mammography">{{screen.mammography}}</label>
      <p-checkbox name="mammography" [(ngModel)]="history.mammography" [binary]="true" [style.marginLeft.px]="16"
        validation>
      </p-checkbox>
    </span>


    <span class="col-3 inline-flex align-items-center">
      <label class="no-margin" for="menarche">{{screen.menarche}}</label>
      <input pInputText class="history__personal-complete-field" name="menarche" [(ngModel)]="history.menarche"
        type="number" validation>
    </span>
    <span class="col-3 inline-flex align-items-center">
      <label class="no-margin" for="menopause">{{screen.menopause}}</label>
      <input pInputText class="history__personal-complete-field" name="menopause" [(ngModel)]="history.menopause"
        type="number" validation>
    </span>
    <span class="col-3 inline-flex align-items-center">
      <label class="no-margin" for="cycle">{{screen.cycle}}</label>
      <input pInputText class="history__personal-complete-field" name="cycle" [(ngModel)]="history.cycle"
        [style.width.px]="150" validation>
    </span>
    <span class="col-3 inline-flex align-items-center">
      <label class="no-margin" for="gestation">{{screen.gestation}}</label>
      <input pInputText class="history__personal-complete-field" name="gestation" [(ngModel)]="history.gestation"
        [style.width.px]="150" validation>
    </span>


    <span class="col-3 inline-flex align-items-center">
      <label class="no-margin" for="birth">{{screen.birth}}</label>
      <input pInputText class="history__personal-complete-field" name="birth" [(ngModel)]="history.birth" type="number"
        validation>
    </span>
    <span class="col-3 inline-flex align-items-center">
      <label class="no-margin" for="misbirth">{{screen.misbirth}}</label>
      <input pInputText class="history__personal-complete-field" name="misbirth" [(ngModel)]="history.misbirth"
        type="number" validation>
    </span>
    <span class="col-3 inline-flex align-items-center">
      <label class="no-margin" for="caesarean">{{screen.caesarean}}</label>
      <input pInputText class="history__personal-complete-field" name="caesarean" [(ngModel)]="history.caesarean"
        type="number" validation>
    </span>
    <span class="col-3 inline-flex align-items-center">
      <label class="no-margin" for="livingChildren">{{screen.livingChildren}}</label>
      <input pInputText class="history__personal-complete-field" name="livingChildren"
        [(ngModel)]="history.livingChildren" type="number" validation>
    </span>


    <span class="col-4 inline-flex align-items-center">
      <label class="no-margin field__label" for="lastMenstruation">{{screen.lastMenstruation}}</label>
      <span [style.margin-left.px]="10">
        <dx-date-box name="lastMenstruation" [value]="history.lastMenstruation!" [placeholder]="screen.datePlaceholder"
          [showClearButton]="true" (onValueChanged)="lastMenstruationChanged($event)"
          [displayFormat]="screen.dateFormatFull" type="date">
        </dx-date-box>
      </span>
    </span>
    <span class="col-4 inline-flex align-items-center">
      <label class="no-margin field__label" for="lastBirth">{{screen.lastBirth}}</label>
      <span [style.margin-left.px]="10">
        <dx-date-box name="lastBirth" [value]="history.lastBirth!" [placeholder]="screen.datePlaceholder"
          [showClearButton]="true" (onValueChanged)="lastBirthChanged($event)" [displayFormat]="screen.dateFormatFull"
          type="date">
        </dx-date-box>
      </span>
    </span>
    <span class="col-4 inline-flex align-items-center">
      <label class="no-margin field__label" for="lastCytology">{{screen.lastCytology}}</label>
      <span [style.margin-left.px]="10">
        <dx-date-box name="lastCytology" [value]="history.lastCytology!" [placeholder]="screen.datePlaceholder"
          [showClearButton]="true" (onValueChanged)="lastCytologyChanged($event)"
          [displayFormat]="screen.dateFormatFull" type="date">
        </dx-date-box>
      </span>
    </span>


    <div class="col-12 px-0 py-0 inline-flex align-items-center">
      <label class="col-2 no-margin" for="familyMethod">{{screen.familyMethod}}</label>
      <div class="col-10">
        <input pInputText name="familyMethod" [(ngModel)]="history.familyMethod" class="no-margin" validation>
      </div>
    </div>

    <div class="col-12 px-0 py-0 inline-flex align-items-center">
      <label class="col-2 no-margin" for="allergy">{{screen.allergy}}</label>
      <div class="col-10">
        <input pInputText name="allergy" [(ngModel)]="history.allergy" class="no-margin" validation>
      </div>
    </div>
  </span>
</div>